module.exports = __webpack_public_path__ + "img/charging-infrastructure-terms-fr.1eb218e8.jpg";